if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        // Stanlee: the explicit share menu (Facebook / Pinterest / X / Email / Copy Link)
        // must always stay reachable, so it is no longer swapped out for navigator.share().
        // This wiring now always runs, regardless of navigator.share support.
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle
          .querySelector('.share-button__copy')
          .addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));

        // Stanlee: close the menu on outside click (native <details> doesn't do this itself).
        this._onDocumentClick = (event) => {
          if (this.mainDetailsToggle.hasAttribute('open') && !this.contains(event.target)) {
            this.close();
          }
        };
        document.addEventListener('click', this._onDocumentClick);
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        const url = this.elements.urlInput.value;

        const showSuccess = () => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        };

        const showFailure = () => {
          // Stanlee: never claim success when copying actually failed.
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = 'Could not copy link. Please copy it manually.';
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        };

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(showSuccess).catch(() => {
            this.fallbackCopyToClipboard(url, showSuccess, showFailure);
          });
        } else {
          // Stanlee: graceful fallback for browsers/contexts without the modern Clipboard API.
          this.fallbackCopyToClipboard(url, showSuccess, showFailure);
        }
      }

      fallbackCopyToClipboard(url, onSuccess, onFailure) {
        try {
          this.elements.urlInput.removeAttribute('readonly');
          this.elements.urlInput.select();
          this.elements.urlInput.setSelectionRange(0, url.length);
          const succeeded = document.execCommand('copy');
          this.elements.urlInput.setAttribute('readonly', '');
          succeeded ? onSuccess() : onFailure();
        } catch (err) {
          this.elements.urlInput.setAttribute('readonly', '');
          onFailure();
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
